import { useCallback, useState } from "react";
import type { U3130ExportEmployeurDRequest } from "./U3130Service";

export interface UseU3130ExportEmployeurDHandlersProps {
  doExportEmployeurDFn: (body: U3130ExportEmployeurDRequest) => Promise<unknown>;
  onSuccess: () => void;
  onError: (params: { error: unknown }) => void;
}

export function useU3130ExportEmployeurDHandlers({
  doExportEmployeurDFn,
  onSuccess,
  onError,
}: UseU3130ExportEmployeurDHandlersProps) {
  const [isExporting, setIsExporting] = useState(false);

  const exportEmployeurD = useCallback(
    async (body: U3130ExportEmployeurDRequest) => {
      if (!body.startDate?.trim() || !body.endDate?.trim()) return;
      setIsExporting(true);
      try {
        await doExportEmployeurDFn(body);
        onSuccess();
      } catch (error: unknown) {
        onError({ error });
      } finally {
        setIsExporting(false);
      }
    },
    [doExportEmployeurDFn, onSuccess, onError],
  );

  return { exportEmployeurD, isExporting };
}
